// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"57":"index","945":"dashboard"}[chunkId] + "." + {"57":"fdafb8b1","945":"6a871fd4"}[chunkId] + ".css";
};